/* 🤖 this file was generated by svg-to-ts */
export const matIconUTurnLeft: {
  name: 'u-turn-left';
  data: string;
} = {
  name: 'u-turn-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 9v12h-2V9c0-2.21-1.79-4-4-4S8 6.79 8 9v4.17l1.59-1.59L11 13l-4 4-4-4 1.41-1.41L6 13.17V9c0-3.31 2.69-6 6-6s6 2.69 6 6z"/></svg>`
};
